/* eslint-disable prettier/prettier */
import getsessionRequest from "./sessionApi"; // alias here

export const checkForceLogout = async () => {
  try {
    const request = await getsessionRequest.getLogingSession({});

    // console.log("✅ API Response:", request);

    const result = request;
    // console.log("🟢 Parsed Response:", result);

    // if (request.status === 200) {
    // 🟢 Check using loginActiveStatus
    if (result.loginActiveStatus === true) {
      console.warn("🚨 FORCE LOGOUT TRIGGERED! loginActiveStatus = true");

      // localStorage.removeItem("authToken");
      // localStorage.removeItem("loginId");
      // localStorage.removeItem("LoginTime");
      // localStorage.removeItem("memberId");
    } else {
      console.log("✅ loginActiveStatus is FALSE → user session safe");
    }
    // } else {
    //   console.error("❌ API Error Status:", request.status);
    // }
  } catch (err) {
    console.error("⚠️ Error checking force logout:", err);
  }
};

// Auto check every 60 seconds
// if (!window.forceLogoutInterval) {
//   console.log("⏳ Interval SET — 6 sec baad start hoga");

//   window.forceLogoutInterval = setInterval(() => {
//     console.log("👀 Interval RUNNING...");

//     const memberId = localStorage.getItem("memberId");
//     const token = localStorage.getItem("authToken");

//     console.log("memberId:", memberId, "token:", token);

//     if (!memberId || !token) {
//       console.log("⛔ No memberId/token → STOP");
//       return;
//     }

//     // checkForceLogout();
//   }, 6000);
// }
